import React from 'react'
import styled from 'styled-components'
const Img = styled.div`
margin-left:1em;
@media (max-width: 415px) {
    img{
        width:200px;
        border-radius:10px;
    }
}
border-radius:10px;
@media (min-width: 415.1px) {


    img{
        width:400px;
        border-radius:10px;
    }
}

`
function VideoYoutube({snippet,contentDetails}) {
    console.log(contentDetails.videoId)
    return (
        <Img>
            <a href={`https://www.youtube.com/watch?v=${contentDetails.videoId}` } target="_blank">
            <img className="img" src={snippet.thumbnails.medium.url}/></a>
        </Img>
    )
}
export default VideoYoutube
